import styled from 'styled-components'

export const Filters = styled.form`
  padding: 14px;
  border: 1px solid ${({ theme }) => theme.palette.colors.cardBorder};
  border-radius: 14px;
  background: ${({ theme }) => theme.palette.colors.controlSurface};
  .MuiInputLabel-root {
    color: ${({ theme }) => theme.palette.colors.muted};
    font-size: 17px;
  }
  .MuiSelect-select, input {
    font-size: 16px;
  }
`;
export const Fields = styled.div`
  display: grid;
  grid-template-columns: minmax(145px, 0.85fr) minmax(145px, 0.85fr) minmax(145px, 0.85fr) minmax(250px, 1.6fr) auto;
  gap: 10px;
  align-items: end;
  @media (max-width: 1040px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media (max-width: 560px) { grid-template-columns: 1fr; }
`;
export const Field = styled.div`
  min-width: ${({ search }) => search ? '230px' : '0'};
`;
export const Actions = styled.div`
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 13px;
  white-space: nowrap;
  @media (max-width: 1040px) { justify-content: flex-start; }
`;
export const Count = styled.strong`
  color: ${({ theme }) => theme.palette.colors.text};
  font-family: Lato, sans-serif;
  font-size: 14px;
`;
